import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, finalize } from 'rxjs/operators';
import { LoadingService } from '../../services/loading-service';
import { throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  const toast = inject(ToastrService);

  const skipLoader = req.headers.has('noLoader');

  const messages: Record<string, Record<string, string>> = {
    PendingAssistancesFound: {
      it: 'Una richiesta di assistenza è già in corso.',
      en: 'An assistance request is already in progress.'
    },
    NegativePartnerChecks: {
      it: 'Non è possibile procedere con la richiesta, verifica con Assistenza Fasdac.',
      en: 'It is not possible to proceed with the request, please check with Fasdac Support.'
    },
    TooManyConnections: {
      it: 'Il profilo ha raggiunto il numero massimo di profili ammessi.',
      en: 'The profile has reached the maximum number of profiles allowed.'
    },
    GENERIC: {
      it: 'Errore nella richiesta.',
      en: 'Request error.'
    },
    SurveyAlreadyPresent: {
      it: 'Hai già inviato il tuo feedback per il consulto.',
      en: 'You have already submitted your feedback for the consultation.'
    }
  };

  if (!skipLoader) {
    loadingService.increment();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skipLoader) {
        loadingService.decrement();
      }
    }),
    catchError((error) => {
      const err = error?.error;
      const lang = localStorage.getItem('lang') || 'it';
      let message = messages['GENERIC'][lang];
      if (err?.userMessage) {
        message = err.userMessage;
      } else if (err?.innerErrorMessage === 'PendingAssistancesFound') {
        message = messages['PendingAssistancesFound'][lang];
      } else if (err?.innerErrorMessage === 'NegativePartnerChecks') {
        message = messages['NegativePartnerChecks'][lang];
      } else if (err?.innerErrorMessage === 'SPA_errorMessagesWebApi.tooManyConnections') {
        message = messages['TooManyConnections'][lang];
      } else if (err?.innerErrorMessage === 'surveyIsAlreadyPresent') {
        message = messages['SurveyAlreadyPresent'][lang];
      }
      toast.error(message);
      return throwError(() => error);
    })
  );
};
